import { AddUserComponent } from './add-user/add-user.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserManagementFormComponent } from './user-management-form/user-management-form.component';
import { UserManagementEditorComponent } from './user-management-editor/user-management-editor.component';

const routes: Routes = [

  {
    path: '', pathMatch: 'full', redirectTo: 'form'
  },
  {
    path: 'form',
    component: UserManagementFormComponent
  },
  {
    path: 'management-editor',
    component: UserManagementEditorComponent
  },
  {
    path: 'add-user',
    component: AddUserComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule { }
